import { GET_PROFILE, PROFILE_ERROR, CLOSE_ACCOUNT, PROFILE_SUCCESS, EDIT_PROFILE, RESET_PROFILE_FLAG } from "./actionTypes"

export const getProfile = userId => {
  return {
    type: GET_PROFILE,
    payload: { userId },
  }
}
export const editProfile = user => {
  return {
    type: EDIT_PROFILE,
    payload: { user },
  }
}
export const closeAccount = () => {
  return {
    type: CLOSE_ACCOUNT,
    payload: null,
  }
}

export const profileSuccess = msg => {
  return {
    type: PROFILE_SUCCESS,
    payload: msg,
  }
}

export const profileError = error => {
  return {
    type: PROFILE_ERROR,
    payload: error,
  }
}

export const resetProfileFlag = error => {
  return {
    type: RESET_PROFILE_FLAG,
  }
}
